import { render, staticRenderFns } from "./card-radio-field.vue?vue&type=template&id=35ed20b0&scoped=true"
import script from "./card-radio-field.vue?vue&type=script&lang=js"
export * from "./card-radio-field.vue?vue&type=script&lang=js"
import style0 from "./card-radio-field.vue?vue&type=style&index=0&id=35ed20b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed20b0",
  null
  
)

export default component.exports